var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCryptoGeneralIconsChevronDownClean = function SvgCryptoGeneralIconsChevronDownClean(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8.7 5.4",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.6 0 4.3 3.3 1 0 0 1l4.3 4.4L8.7 1 7.6 0z"
  })));
};

export { SvgCryptoGeneralIconsChevronDownClean as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA4LjcgNS40Ij48cGF0aCBkPSJNNy42IDBMNC4zIDMuMyAxIDAgMCAxbDQuMyA0LjRMOC43IDEgNy42IDB6Ii8+PC9zdmc+";